export interface TeamMember {
  id: string;
  name: string;
  initials: string;
  role: string;
  completedModules: number;
  assignedModules: number;
  lastActivity: string; // display string, e.g. "2 Aug 2026" or "Never opened"
  status: 'complete' | 'in_progress' | 'past_due';
}

// 6 named people, matching the source design mock's roster exactly. The
// mock's own "8 people" / "8 of 10 seats" header text didn't match its own
// 6-row table — an inconsistency in the reference mock, not something to
// reproduce. This fixture is internally consistent: 6 people, 6 seats used.
export const TEAM_ROSTER: TeamMember[] = [
  { id: 'dr', name: 'Dana Reyes', initials: 'DR', role: 'Operations', completedModules: 4, assignedModules: 4, lastActivity: '2 Aug 2026', status: 'complete' },
  { id: 'mt', name: 'Marcus Tan', initials: 'MT', role: 'Sales', completedModules: 4, assignedModules: 4, lastActivity: '29 Jul 2026', status: 'complete' },
  { id: 'lc', name: 'Lena Castillo', initials: 'LC', role: 'Closings', completedModules: 4, assignedModules: 4, lastActivity: '1 Aug 2026', status: 'complete' },
  { id: 'po', name: 'Priya Okafor', initials: 'PO', role: 'Closings', completedModules: 3, assignedModules: 4, lastActivity: '4 Aug 2026', status: 'in_progress' },
  { id: 'jh', name: 'Jordan Hale', initials: 'JH', role: 'Sales', completedModules: 1, assignedModules: 4, lastActivity: '21 Jul 2026', status: 'past_due' },
  { id: 'sb', name: 'Sam Brennan', initials: 'SB', role: 'Admin', completedModules: 0, assignedModules: 4, lastActivity: 'Never opened', status: 'past_due' },
];

export const SEATS_USED = TEAM_ROSTER.length;
export const SEATS_TOTAL = 10;

export interface CompletionRecord {
  personId: string;
  personName: string;
  initials: string;
  moduleNumber: number;
  moduleTitle: string;
  completedOn: string;
  knowledgeCheckPassed: boolean;
  knowledgeCheckScore: string; // e.g. "5 of 5"
}

// Matches the mock's rows exactly (6 records — same internal-consistency
// fix as TEAM_ROSTER above; the mock's own "17 records" header didn't match
// its 6-row table).
export const COMPLETION_RECORDS: CompletionRecord[] = [
  { personId: 'dr', personName: 'Dana Reyes', initials: 'DR', moduleNumber: 4, moduleTitle: 'Wire fraud and payment redirection', completedOn: '2 Aug 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '5 of 5' },
  { personId: 'dr', personName: 'Dana Reyes', initials: 'DR', moduleNumber: 3, moduleTitle: 'Impersonation and the urgent request', completedOn: '28 Jul 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '4 of 5' },
  { personId: 'lc', personName: 'Lena Castillo', initials: 'LC', moduleNumber: 4, moduleTitle: 'Wire fraud and payment redirection', completedOn: '1 Aug 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '5 of 5' },
  { personId: 'mt', personName: 'Marcus Tan', initials: 'MT', moduleNumber: 2, moduleTitle: 'Phishing, texts, and fake invoices', completedOn: '29 Jul 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '4 of 5' },
  { personId: 'po', personName: 'Priya Okafor', initials: 'PO', moduleNumber: 1, moduleTitle: 'How a scam actually works', completedOn: '24 Jul 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '5 of 5' },
  { personId: 'jh', personName: 'Jordan Hale', initials: 'JH', moduleNumber: 1, moduleTitle: 'How a scam actually works', completedOn: '21 Jul 2026', knowledgeCheckPassed: true, knowledgeCheckScore: '4 of 5' },
];
